import React from 'react';
import './App.css';
import { Header, HomePage } from "./components/index.js";
import { AppContext } from "./components/AppContext";
import { getTermsAndConditions } from "./components/Services"
const isMobile = window.innerWidth <= 767 ? true : false


class App extends React.Component {
  state = {}
  componentDidMount() {
    this.getTermsData()
  }

  getTermsData = async () => {
    let termsData = await getTermsAndConditions({})
    this.setState({ termsData })
  }
  setShowVideo = () => {
    this.setState({ showVideo: !this.state.showVideo })
  }
  render() {
    let { showVideo, termsData } = this.state || {}
    return (
      <AppContext.Provider value={{
        showVideo,
        termsData,
        setShowVideo: this.setShowVideo
      }}>
        <div className="main flex column">
          <Header showVedio isMobile={isMobile} />
          <div className="flex flex-1 scroll">
            <HomePage isMobile={isMobile} />
          </div>
        </div>
      </AppContext.Provider>
    );
  }
}

export default App;
